<template>
  <div>
    <label
      v-if="label"
      class="pl-2 label-text"
      >{{ label }}</label
    >
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="date"
      transition="scale-transition"
      offset-y
      min-width="auto"
      class="mt-0 pt-0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :disabled="disabled"
          v-model="dateFormatted"
          class="mt-1 rounded-lg py-0 mini-text field-edit"
          outlined
          dense
          :class="errorMessages && errorMessages.length ? 'field-error' : ''"
          :placeholder="placeholder"
          :clearable="clearable"
          :hide-details="hideDetails"
          :height="20"
          :hint="hint"
          :persistent-hint="persistentHint"
          append-icon="mdi-calendar"
          v-bind="attrs"
          v-on="on"
          v-mask="'##.##.####'"
          :error-messages="errorMessages"
          @change="setDate"
          @click:clear="clear"
          @blur="$emit('blur')"
        >
          <template v-slot:append="">
            <v-icon
              class="uikit-icon no-icon-transition calendar size-20"
              style="margin-top: 1px"
              :class="{
                'primary-color': menu
              }"
            />
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        v-model="date"
        locale="ru-RU"
        :allowed-dates="allowedDates"
        color="green primary"
        format="DD.MM.YYYY"
        first-day-of-week="1"
        :max="max"
        @input="save(date)"
        no-title
        scrollable
      >
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import { dateFormat } from '@/scripts/validation'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UIDatePickerMenu',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    allowedDates: {
      type: Function,
      default: null
    },
    value: String,
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Выберите значение'
    },
    errorMessages: Array,
    hint: {
      type: String,
      default: ''
    },
    persistentHint: {
      type: Boolean,
      default: true
    },
    limitMaxToMaxDictionaryYear: {
      type: Boolean,
      default: false
    }
  },

  components: {},

  created() {
    if (this.limitMaxToMaxDictionaryYear) {
      this.getDictionaries(['year'])
    }
  },

  mounted() {
    if (!this.date) this.date = this.value
  },

  data: () => {
    return {
      menu: false,
      date: null,
      dateFormatted: null,
      clicks: 0,
      timer: null,
      delay: 200
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['yearList']),

    max() {
      return this.limitMaxToMaxDictionaryYear && this.yearList.length
        ? `${[...this.yearList].sort((a, b) => b.year - a.year)[0].year}-12-31`
        : null
    }
  },

  methods: {
    ...mapActions('dictionaries', ['getDictionaries']),

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },

    clear() {
      this.date = null
      this.save(null)
    },

    save(date) {
      this.$refs.menu.save(date)
      this.$emit('input', date)
      this.$emit('change', date)
    },

    setDate(newDate) {
      const date = newDate ? newDate.split('.').reverse().join('-') : ''
      if (dateFormat(date)) {
        this.$refs.menu.save(date)
        this.$emit('input', date)
        this.$emit('change', date)
      } else {
        this.dateFormatted = this.formatDate(this.value)
        this.setDate(this.dateFormatted)
      }
    }
  },

  watch: {
    value(v) {
      this.date = v
    },

    date(v) {
      this.dateFormatted = this.formatDate(v)
    }
  }
}
</script>

<style scoped>
.primary-color {
  background: var(--v-primary-base) !important;
}
</style>
